/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  titleVytvoreni: {
    id: "b2b.smlouva-vytvoreni.title.vytvoreni",
    defaultMessage: "New Contract"
  },
  titleEdit: {
    id: "b2b.smlouva-vytvoreni.title.edit",
    defaultMessage: "Edit Contract"
  },
  saveDialogTitle: {
    id: "b2b.smlouva-vytvoreni.save-dialog.title",
    defaultMessage: "Save Contract"
  },
  buttonSubmitVytvoreni: {
    id: "b2b.smlouva-vytvoreni.button.submit-vytvoreni",
    defaultMessage: "Create"
  },
  buttonSubmitEdit: {
    id: "b2b.smlouva-vytvoreni.button.submit-edit",
    defaultMessage: "Save"
  },
  buttonCancel: {
    id: "b2b.smlouva-vytvoreni.button.cancel",
    defaultMessage: "Cancel"
  },
  cisloLabel: {
    id: "b2b.smlouva-vytvoreni.field.cislo.label",
    defaultMessage: "Contract Number"
  },
  popisLabel: {
    id: "b2b.smlouva-vytvoreni.field.popis.label",
    defaultMessage: "Description"
  },
  fixMoLabel: {
    id: "b2b.smlouva-vytvoreni.field.fixMo.label",
    defaultMessage: "Fixed Requirements for STR"
  },
  fixVoLabel: {
    id: "b2b.smlouva-vytvoreni.field.fixVo.label",
    defaultMessage: "Fixed Requirements for LTR"
  },
  platnostOdLabel: {
    id: "b2b.smlouva-vytvoreni.field.platnostOd.label",
    defaultMessage: "Validity From"
  },
  platnostDoLabel: {
    id: "b2b.smlouva-vytvoreni.field.platnostDo.label",
    defaultMessage: "Validity To"
  }
});

export default () => useMessages(MESSAGES);
